const translations = {
  title: 'Creando presentación de pantalla',
  title_edit: 'Editando presentación de pantalla',
  title_cloning: 'Clonando presentación de pantalla',
  name: 'Nombre*',
  userGroups: 'Grupos de usuarios',
  columnTitle: 'Creando columna',
  columnTitle_edit: 'Editando columna',
  columnTitle_cloning: 'Clonando columna',
  color: 'Color',
  filters: 'Filtros',
  widgetTitle: 'Agregando widget',
  widgetTitle_edit: 'Editando widget',
  selectWidget: 'Seleccione un widget'
}

export default translations
